
const Tabs = (props) => (
  <section>
    <div className="tab-row">
      {props.routes.map((route) => (
        <button
          key={route.id}
          disabled={route.disabled}
          className={`tab-btn ${route.id === props.active
            ? 'tab-btn--active'
            : ''
            }`}
          onClick={() => {
           route.onChange ? route.onChange(() => props.setActive(route.id)) : props.setActive(route.id)
          }}
        >
          {route.label}
        </button>
      ))}
    </div>
    <div className="tab-content">
      {props.children}
    </div>
  </section>
);

export default Tabs;
